import {
  RatingInput,
  RatingTextInput,
  Section,
  SuccessAlert,
} from '@/components';
import APP_CONFIG from '@/config/app';
import { FC, useState } from 'react';
import { useForm } from 'react-hook-form';
const { MAIN_GAP } = APP_CONFIG.STYLES;
const spacingConfig = {
  gap: `gap${MAIN_GAP}`,
};
interface QuestionAnswer {
  question: string;
  rating: number;
}
interface YieldBearingAssetRiskAssessmentSectionProps {
  onAssessmentChange: (
    qaList: QuestionAnswer[],
    userCommentary?: string,
  ) => void;
}
const YieldBearingAssetRiskAssessmentSection: FC<
  YieldBearingAssetRiskAssessmentSectionProps
> = ({ onAssessmentChange }) => {
  const questions = [
    'How do you feel about waiting a few years to see returns?',
    'How do you feel about unrealized losses over a few months?',
    'How do you feel about taking on more risk for higher returns?',
    'How do you feel about market volatility over a few months?',
    'How do you feel about unpredictable outcomes?',
  ];
  const [qaList, setQaList] = useState<QuestionAnswer[]>(
    questions.map((q) => ({ question: q, rating: 0 })),
  );
  const [userCommentary, setUserCommentary] = useState<string>('');
  const methods = useForm({ defaultValues: { question0: 0 } });
  const handleAnswerChange = (index: number, newRating: number) => {
    const updated = [...qaList];
    updated[index] = {
      question: updated[index].question,
      rating: newRating,
    };
    setQaList(updated);
    onAssessmentChange(updated, userCommentary);
  };
  return (
    <SuccessAlert
      title="Let's assess your risk tolerance."
      description="Answer a few quick questions to help us understand your comfort level with risk. This will guide us in recommending an optimal composition tailored to your financial goals."
      extraContent={
        <div className={`flex flex-col w-full pt-3 ${spacingConfig.gap}`}>
          {qaList.map((qa, index) => (
            <Section
              key={`question-${index}`}
              body={
                <RatingInput
                  value={qa.rating}
                  onChange={(value) => handleAnswerChange(index, value)}
                  name={`question${index}`}
                  errors={methods.formState.errors}
                  clearErrors={methods.clearErrors}
                  showError={false}
                  label={qa.question}
                />
              }
            />
          ))}
          <Section
            key="user-commentary"
            body={
              <RatingTextInput
                value={userCommentary}
                onChange={(value) => {
                  setUserCommentary(value);
                  onAssessmentChange(qaList, value);
                }}
                name="userCommentary"
                errors={methods.formState.errors}
                clearErrors={methods.clearErrors}
                showError={false}
                label="Is there anything else you'd like us to consider?"
                placeholder="Tell us about your investment goals, preferences, or any specific concerns."
                multiLine={true}
                noOfLines={4}
              />
            }
          />
        </div>
      }
    />
  );
};
export default YieldBearingAssetRiskAssessmentSection;
